

















import RecessAPI from '@services/RecessAPI'
import VueOptions from '@utils/VueOptions'

settings =
  name: 'PasswordEdit'
  vue:
    store: ['member']
    components: { RequestButton }
    data: ->
      change_password:
        current_password: null
        new_password: null
        new_password_confirmation: null
    methods:
      saveClicked: -> RecessAPI.changePassword {  @change_password }
export default VueOptions.vue settings

